import React, { createContext, useContext } from "react";

const AbilityContext = createContext(null);

export const AbilityProvider = ({ ability, children }) => (
  <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>
);

export const useAbility = () => useContext(AbilityContext);
